var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandymanBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    fill: "#444A55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 43.95q-.3 0-.55-.075-.25-.075-.5-.325L25.9 32.3v-3.8l2.55-2.55h3.8L43.5 37.2q.25.25.325.5.075.25.075.55 0 .3-.075.55-.075.25-.325.5l-4.25 4.25q-.25.25-.5.325-.25.075-.55.075Zm0-3.55 2.15-2.15-10-10-2.15 2.15ZM9.75 44q-.3 0-.575-.1-.275-.1-.525-.35l-4.2-4.2q-.25-.25-.35-.525-.1-.275-.1-.575 0-.3.1-.55.1-.25.35-.5L15.7 25.95h4.25l1.9-1.9-8.75-8.75h-2.85L4 9.05 8.95 4.1l6.25 6.25v2.85l8.75 8.75 6.5-6.5-3.35-3.35 2.8-2.8h-5.65l-.9-.9 6.4-6.4.9.9v5.65l2.8-2.8 8.45 8.45q.75.75 1.175 1.725.425.975.425 2.075 0 .95-.3 1.875t-.95 1.725L38 17.35l-2.8 2.8-2.6-2.6L22.05 28.1v4.2L10.8 43.55q-.25.25-.5.35-.25.1-.55.1Zm0-3.6 10-10-2.15-2.15-10 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandymanBlack);
export default __webpack_public_path__ + "static/media/handyman_black.31a033c1048ec03300abceb9fc8c866a.svg";
export { ForwardRef as ReactComponent };